import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const maquinasVirtualesRoutes = [
  {
    component: Loadable(
      lazy(() => import('../pages/maquinas-virtuales/Listar')),
    ),
    path: PATH_DASHBOARD.maquinas_virtuales.listar.path,
    shouldRender: PATH_DASHBOARD.maquinas_virtuales.listar.renderCondition,
  },
];

export default maquinasVirtualesRoutes;
